import React, { useCallback } from 'react';
//@ts-ignore
import GoogleMapReact from 'google-map-react';
import ContactForm from '../ContactForm/ContactForm';
import { colors } from '../../constants/colors';
import { styled } from '@mui/material/styles';
import mapStyles from './MapStyles';

type MapProps = {
}

const StyledAppBar = styled('section')(({ theme }) => mapStyles());

const Map:React.FC<MapProps> = (props) => {
  const defaultProps = {
    center: {
      lat: 19.900108,
      lng: -98.605482
    },
    zoom: 15
  };

  const Marker:React.FC<any> = (props) => {
    return <a target="_blank" href="https://www.google.com/maps/place/19.900293,-98.605517">
      <svg height="24" stroke='#e74c3c' fill='#e74c3c' version="1.1" width="24"><g transform="translate(0 -1028.4)"><path d="m12.031 1030.4c-3.8657 0-6.9998 3.1-6.9998 7 0 1.3 0.4017 2.6 1.0938 3.7 0.0334 0.1 0.059 0.1 0.0938 0.2l4.3432 8c0.204 0.6 0.782 1.1 1.438 1.1s1.202-0.5 1.406-1.1l4.844-8.7c0.499-1 0.781-2.1 0.781-3.2 0-3.9-3.134-7-7-7zm-0.031 3.9c1.933 0 3.5 1.6 3.5 3.5 0 2-1.567 3.5-3.5 3.5s-3.5-1.5-3.5-3.5c0-1.9 1.567-3.5 3.5-3.5z" fill="#e74c3c"/><path d="m12.031 1.0312c-3.8657 0-6.9998 3.134-6.9998 7 0 1.383 0.4017 2.6648 1.0938 3.7498 0.0334 0.053 0.059 0.105 0.0938 0.157l4.3432 8.062c0.204 0.586 0.782 1.031 1.438 1.031s1.202-0.445 1.406-1.031l4.844-8.75c0.499-0.963 0.781-2.06 0.781-3.2188 0-3.866-3.134-7-7-7zm-0.031 3.9688c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5 1.567-3.5 3.5-3.5z" fill="#e74c3c" transform="translate(0 1028.4)"/></g></svg>
    </a>
  }
  
  const GoogleMap = useCallback(() => (
    <GoogleMapReact
      bootstrapURLKeys={{ key: "AIzaSyCOHwFFRqzFaAZXDCLeGQMZhcl2PS77fAA" }}
      defaultCenter={defaultProps.center}
      defaultZoom={defaultProps.zoom}
    >
      <Marker
        lat={19.900108}
        lng={-98.605482}
      />
    </GoogleMapReact>
  ), [])

  return (
    <StyledAppBar className='flex items-center flex-col justify-center py-24' style={{ backgroundColor: colors.tertiary }}>
      <div className="container w-full lg:pt-[3rem] flex flex-col lg:flex-row">
        <div id="card-container" className="p-8 mx-8 lg:mx-0 lg:mr-4 rounded-lg">
          <div className='flex flex-col'>
            <div className='font-bold text-2xl'>Contáctanos</div>
            <div className="mt-4">Para asesorarte adecuadamente, por favor llena el formulario o comunícate con nosotros</div>
            <div className="mt-6 text-zinc-400">Teléfono</div>
            <a href="tel:+527751558565" className="mt-2 mb-4 text-zinc-950">775 155 8565</a>
            <div className="pt-4 border-0 border-t-[1px] border-solid border-zinc-200 text-zinc-400">Email</div>
            <div className="mt-2 mb-4">gmalex7@gmail.com</div>
            <div className="pt-4 border-0 border-t-[1px] border-solid border-zinc-200 text-zinc-400">Ubicación</div>
            <div className="mt-2 mb-4">México Km 60, Santa Gertrudis, 43855 Zempoala, Hgo</div>
          </div>
        </div>
        <div id="card-container" className="p-8 mx-8 lg:mx-0 mt-8 lg:mt-0 lg:ml-4 rounded-lg">
          <ContactForm />
        </div>
      </div>
      <div className='container w-full'>
        <div id="card-container" className='p-8 mt-8 mx-8 lg:mx-0 rounded-lg'>
          <div className='mb-6 font-bold text-2xl'>Encuentranos en Google Maps</div>
          <div className='mb-6'>Da click en el marcador rojo para abrir nuestra ubicación</div>
          <div className="h-[40rem] lg:h-[48rem] rounded-md overflow-hidden">
            <GoogleMap/>
          </div>
        </div>
      </div>
    </StyledAppBar>
  )
}


export default Map;